import React from 'react';
import HeaderOne from "../common/header/HeaderOne";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import SinglePortfolioContent from '../components/single-portfolio/SinglePortfolioContent';
import BrandOne from '../components/brand/BrandOne';
import FooterOne from '../common/footer/FooterOne';

const PortfolioDetails = () => {
    return (
        <>
            <HeaderOne />
            <Breadcrumb
                heading="Portfolio Details"
                currentPage="Portfolio Details" 
            />
            <SinglePortfolioContent />
            <BrandOne />
            <FooterOne />
        </>
    )
}

export default PortfolioDetails;